<template>
  <div class="middle-map-outer">
    <div class="check-top" @click="onCheckTop">
      <img class="icon" src="@/assets/images/map-1.png" alt="">
      <span class="tip">全市数据</span>
    </div>
    <div>
      <div id="mapChartDom" class="chart-canvas"></div>
    </div>
  </div>
</template>

<script>
import {
  data_v2_maps,
} from '@/api/portal'
import {mapMutations,mapGetters} from 'vuex'

export default {
  data() {
    return {
      chartInstance: null,
      currentGeoData:{}
    };
  },
  computed: {
    ...mapGetters(['selectLocId','siteInfo']),
    chartDom() {
      return document.getElementById("mapChartDom");
    },
    charOption() {
      return {
        tooltip: {
          show: true,
          backgroundColor: '#033b77',
          borderColor: '#21f2c4',
          textStyle: {
            color: '#fff',
            fontSize: 13
          },
          formatter: (params) => {
            return `挂牌项目：${params.data.listingCnt}（宗）
              <br/>
              成交项目：${params.data.dealCnt}（宗）
              <br/>
              成交金额：${params.data.dealPrice}（${params.data.dealPriceUnit || ''}元）
            `
          }
        },
        // 添加重影
        geo: [
          {
            map: "areamap",
            zoom: 1,
            zLevel: 0,
            roam: false, // 禁止拖拽
            silent: true,
            label: {
              show: false,
            },
            itemStyle: {
              shadowColor: "#015BB5",
              shadowOffsetY:  22,
              shadowOffsetX: 0,
              shadowBlur: 1
            },
          },
          {
            map: "areamap",
            zoom: 1,
            zLevel: 0,
            roam: false, // 禁止拖拽
            silent: true,
            label: {
              show: false,
            },
            itemStyle: {
              shadowColor: "#A1EBF3",
              shadowOffsetY:  12,
              shadowOffsetX: 0,
              shadowBlur: 1
            },
          },
          {
            map: "areamap",
            zoom: 1,
            zLevel: 0,
            roam: false, // 禁止拖拽
            silent: true,
            label: {
              show: false,
            },
            itemStyle: {
              shadowColor: "#06A9FF",
              shadowOffsetY:  7,
              shadowOffsetX: 0,
            },
          }
        ],
        series: [
          {
            zlevel: 5,
            type: "map",
            map: "areamap",
            label: {
              show: true,
              color: "#fff",
              normal: {
                show: true, // 显示省份标签
                textStyle: {
                  color: '#fff'
                } // 省份标签字体颜色
              }
            },
            itemStyle:{
              areaColor: '#01215c',
              borderWidth: 1,
              borderColor: '#9ffcff',
              // 阴影颜色
              shadowColor: 'rgba(9, 140, 255, 0.9)',
              shadowBlur: 4
            },
            data: this.currentGeoData.features.map(i=>i.properties),
            emphasis: {
              label: {
                color: "#fff",
              },
              itemStyle: {
                borderWidth: 0,
                shadowColor: "rgba(22, 87, 200, 0.5)",
                shadowBlur: 5,
                shadowOffsetY: 5,
                borderColor: "rgba(255,255,255,1)",
                areaColor: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#E8B244", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#E8B244", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
            select: {
              label: {
                color: "#fff",
              },
              itemStyle: {
                borderWidth: 0,
                shadowColor: "rgba(22, 87, 200, 0.5)",
                shadowBlur: 20,
                shadowOffsetY: 20,
                borderColor: "rgba(255,255,255,1)",
                areaColor: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#E8B244", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#E8B244", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
            aspectScale: 0.75,
            zoom: 1,
          },
          // {
          //   type: 'effectScatter',
          //   coordinateSystem: 'geo',
          //   zlevel: 10,
          //   symbol: 'circle',
          //   rippleEffect: {
          //     color: '#FDD835',
          //     number: 2,
          //     scale: 8,
          //     brushType: 'fill'
          //   },
          //   itemStyle: {
          //     color: '#FDD835'
          //   },
          //   data: this.currentGeoData.features.map(i=>i.properties)
          // }
        ],
      };
    },
  },
  created(){
  },
  async mounted() {
    let loadingInstance = this.$loading({
      lock: true,
      text: '加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    await this.getLocInfo(this.siteInfo.locId)
    this.$nextTick(() => {
      this.initChart();
      loadingInstance.close()
    });
  },
  methods: {
    ...mapMutations({
      setSelectLocId:'bigdata/setSelectLocId'
    }),

    initChart() {
      this.chartInstance = echarts.init(this.chartDom);
      echarts.registerMap("areamap", this.currentGeoData);
      this.chartInstance.setOption(this.charOption);
      this.chartInstance.on('click',this.handleMapClick)
    },
    // 切换全市
    async onCheckTop(){
      this.chartInstance.clear();
      let loadingInstance = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.setSelectLocId(this.siteInfo.locId,this.siteInfo.locName)
      await this.getLocInfo(this.selectLocId)
      this.initChart()
      loadingInstance.close()
    },
    // 地图点击
    async handleMapClick(e){
      let loadingInstance = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.setSelectLocId(e.data.locId,e.data.locName)
      await this.getLocInfo(this.selectLocId)
      this.initChart()
      loadingInstance.close()
    },
    // 获取地区
    async getLocInfo(locId){
      let {data} = await data_v2_maps({
        locId,
      })
      this.currentGeoData = data
      this.formattingCoordinates(this.currentGeoData.features)
    },
    // 格式化coordinates
    formattingCoordinates(features){
      features.forEach(item=>{
        item.geometry.coordinates = JSON.parse(item.geometry.coordinates)
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.middle-map-outer {
  position: relative;
  .check-top{
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    left: 0;
    top: 50px;
    color: #fff;
    font-weight: bold;
    font-size: 14px;
    cursor: pointer;
    z-index: 10;
    .icon{
      width: 45px;
    }
    .tip{
      margin-top: 5px;
    }
  }
  .chart-canvas{
    height: 600px;
  }
}
</style>